const typeOperation = {
  INCREASE_WALLET_FOR_ADVERTISE_BANNER: 1,
  INCREASE_WALLET_BY_ADMIN: 2,
  DECREMENT_WALLET_BY_ADMIN: 3,
};

const getTypeOperationString = () => {
  let data = [];
  data[typeOperation.INCREASE_WALLET_FOR_ADVERTISE_BANNER] =
    "افزایش موجودی بوسیله تبلغ بنری";
  data[typeOperation.INCREASE_WALLET_BY_ADMIN] = "افزایش موجودی بوسیله ادمین";
  data[typeOperation.DECREMENT_WALLET_BY_ADMIN] = "کاهش موجودی بوسیله ادمین";
  return data;
};

export default {
  typeOperation,
  getTypeOperationString,
};
